'use strict'

import { codeData } from '../utils/codeData';
import utils from '@/utils';


const handleCode = (code) => {
    let authorCode = window.localStorage.getItem('authorCode') ? window.localStorage.getItem('authorCode').split(',') : []
    return utils.codeStatus(authorCode, code);
}

const safer = {
    path: 'task',
    name: 'task-square',
    meta: {
        title: '任务广场',
        name: '任务广场',
        tagsTitle: '任务广场',
        code: ''
    },
    component: () => import('@/components/RouterViewTab'),
    redirect: {
        name: 'mission-square'
    },
    children:[
        {
            path: '',
            name: 'mission-square',
            meta: {
                title: '任务广场',
                name: '',
                tagsTitle: '任务广场',
                code: ''
            },
            redirect: {
                name: 'mission-square-all'
            },
            component: () => import('@/components/RouterView'),
            children: [
                {
                    path: 'all',
                    name: 'mission-square-all',
                    meta: {
                        title: '任务广场-全部-秀川结算中心-综合服务平台',
                        name: '',
                        tagsTitle: '任务广场',
                        tabIndex: 0,
                        isShowTab: true,
                        code: ''
                    },
                    component: () => import('@/pages/missionSquare/AllMission'),
                },
                {
                    path: 'published',
                    name: 'mission-square-published',
                    meta: {
                        title: '任务广场-已发布-秀川结算中心-综合服务平台',
                        name: '',
                        tagsTitle: '任务广场',
                        tabIndex: 1,
                        isShowTab: true,
                        code: ''
                    },
                    component: () => import('@/pages/missionSquare/PublishedMission'),
                },
                {
                    path: 'unpublished',
                    name: 'mission-square-unpublished',
                    meta: {
                        title: '任务广场-未发布-秀川结算中心-综合服务平台',
                        name: '',
                        tagsTitle: '任务广场',
                        tabIndex: 2,
                        isShowTab: true,
                        code: ''
                    },
                    component: () => import('@/pages/missionSquare/UnPublishedMission'),
                },
            ]
        },
        {
            path: ':id',
            name: 'mission-detail',
            meta: {
                title: '任务详情-秀川结算中心-综合服务平台',
                name: '任务详情',
                tagsTitle: '任务详情',
                isShowTab: false,
                code: ''
            },
            redirect:()=>{
                let tabList = [
                    {
                        routeName: 'mission-detail-manage',
                        code:''
                    },
                    {
                        routeName: 'mission-detail-acceptance',
                        code: ''
                    },
                    {
                        routeName: 'mission-detail-list',
                        code: ''
                    }
                ]
                for (let i = 0; i < tabList.length; i++) {

                    if (handleCode(tabList[i].code)) {
                        return {
                            name: tabList[i].routeName
                        }
                    }
                }
            },
            component: () => import('@/components/RouterView'),
            children: [
                {
                    path: 'manage',
                    name: 'mission-detail-manage',
                    meta: {
                        title: '任务详情-个体报名-秀川结算中心-综合服务平台',
                        name: '个体报名',
                        tagsTitle: '个体报名',
                        tabIndex: 1,
                        isShowTab: false,
                        isShowManageTab: true,
                        code:''
                    },
                    component: () => import('@/pages/missionSquare/MissionDetailManage'),
                },
                {
                    path: 'acceptance',
                    name: 'mission-detail-acceptance',
                    meta: {
                        title: '任务详情-验收任务-秀川结算中心-综合服务平台',
                        name: '验收任务',
                        tagsTitle: '验收任务',
                        tabIndex: 2,
                        isShowTab: false,
                        isShowManageTab: true,
                        code: ''
                    },
                    component: () => import('@/pages/missionSquare/MissionDetailAcceptance'),
                },
                {
                    path: 'list',
                    name: 'mission-detail-list',
                    meta: {
                        title: '任务详情-结算任务-秀川结算中心-综合服务平台',
                        name: '结算任务',
                        tagsTitle: '结算任务',
                        tabIndex: 3,
                        isShowTab: false,
                        isShowManageTab: true,
                        code: ''
                    },
                    component: () => import('@/pages/missionSquare/MissionDetailList'),
                },
            ]
        },
    ]
    
};


export default safer;